import { ProductList } from 'components/product/product-list/ProductList'
import { useLocation, useSearchParams } from 'react-router-dom'
import { useEffect, useState } from 'react'
import { downloadFile, getAllQueryParams, getObjectName, setQueryParams } from 'utils/utils'
import { FILTER_PARAMS, INITIAL_ADVANCE_FILTER, INITIAL_DATA_FILTER } from 'configs/product/configTableProductList'
import { useFetch } from 'services/useFetch'
import { API_PRODUCT } from 'services/apiProduct'
import moment from 'moment'
import { Alert } from 'avo-ui'

const INIT_STATUS = [
    {
        label: 'Publish',
        value: 'publish',
    },
    {
        label: 'Draft',
        value: 'draft',
    },
    {
        label: 'Delete',
        value: 'delete',
    },
]

export const ProductListContainer = () => {
    const location = useLocation()
    const [searchParams, setSearchParams] = useSearchParams()
    const [queryFilter, setQueryFilter] = useState({})
    const [queryList, setQueryList] = useState({})
    const query = searchParams.size > 0 ? getAllQueryParams(searchParams) : INITIAL_DATA_FILTER
    const [selectedIds, setSelectedIds] = useState([])
    const [selectedStatus, setSelectedStatus] = useState(INIT_STATUS[0])
    const [modalMessage, setModalMessage] = useState('')
    const [isResetSelectedItem, setIsResetSelectedItem] = useState(false)
    const { fetching: getProductList, data: productList, isLoading } = useFetch(API_PRODUCT.LIST)
    const { fetching: exportProduct, isLoading: isExporting } = useFetch(API_PRODUCT.EXPORT)
    const { fetching: bulkAction, isLoading: isBulkAction } = useFetch(API_PRODUCT.BULK_ACTION)
    const [modal, setModal] = useState({
        filter: false,
        export: false,
        confirm: false,
        delete: false,
        sync: false,
    })

    useEffect(() => {
        const currentQuery = { ...query }
        const newQueryFilter = { ...INITIAL_ADVANCE_FILTER }
        Object.entries(currentQuery).forEach(([key, item]) => {
            if (FILTER_PARAMS?.includes(key) && key !== 'status') {
                const splitObject = item?.split('|')
                const parseObject = splitObject?.map((i) => JSON.parse(i))
                newQueryFilter[key] = parseObject
                currentQuery[key] = parseObject?.map((i) => i?.value)
            } else if (key === 'status') {
                const valueOfQuery = item?.split(',')
                newQueryFilter[key] = valueOfQuery
                currentQuery[key] = valueOfQuery
            }
        })
        setQueryFilter({ ...queryFilter, ...newQueryFilter })
        setQueryList(currentQuery)
        fetchProductList(currentQuery)
    }, [location?.search])

    const onChangeQuery = (queryParams) => {
        const isReset = getObjectName(queryParams)?.some((item) => ['search', 'category_ids'].includes(item))
        if (isReset) setIsResetSelectedItem(!isResetSelectedItem)
        const params = setQueryParams({ ...query, ...queryParams })
        setSearchParams(params, { replace: true })
    }

    const setShowModal = (item) => {
        setModal({ ...modal, ...item })
    }

    const setShowAlert = (message, itemModal) => {
        setShowModal(itemModal)
        return Alert({
            icon: 'success',
            title: 'Success',
            message,
        })
    }

    const fetchProductList = (item = { ...queryList }) => {
        getProductList(item)
    }

    const onSelectSort = (value) => {
        const splitSort = value?.split('-')
        onChangeQuery({ order_by: splitSort[0], order_type: splitSort[1] })
    }

    const onFilter = (filter) => {
        const queryFilter = getQueryAdvanceFilter(filter)
        onChangeQuery({ ...queryFilter, page: 1 })
        setShowModal({ filter: false })
    }

    const getQueryAdvanceFilter = (filter) => {
        const queryFilter = { ...filter }
        Object.entries(queryFilter).forEach(([key, item]) => {
            if (item[0]?.label) {
                const mapData = item.map((i) => JSON.stringify(i))
                queryFilter[key] = mapData.join('|')
            } else {
                queryFilter[key] = item.join(',')
            }
        })
        return queryFilter
    }

    const onExport = () => {
        const { page, limit, ...queryRest } = queryList
        const payload = { ...queryRest, product_ids: selectedIds }
        exportProduct(payload, '', {}, 'blob').then((response) => {
            downloadFile(null, response, `Product-Export-${moment().format('DD-MM-YYYY')}.xlsx`)
            setShowAlert('Product Exported', { export: false })
        })
    }

    const onSelectItemHandler = (item) => {
        const ids = item?.map((i) => i?.id)
        setSelectedIds(ids)
    }

    const onChangeStatus = (item) => {
        setSelectedStatus(item?.value)
    }

    const onApply = () => {
        if (selectedStatus?.value === INIT_STATUS[2].value) {
            setModalMessage('Are You Sure to Delete Product?')
            setShowModal({ delete: true })
        } else {
            setModalMessage(`Are You Sure to Change Product Status to ${selectedStatus?.label}?`)
            setShowModal({ confirm: true })
        }
    }

    const onConfirm = () => {
        const payload = {
            product_ids: selectedIds,
            action: selectedStatus?.value,
        }
        bulkAction(payload)
            .then(() => {
                const itemModal = selectedStatus?.value === 'delete' ? { delete: false } : { confirm: false }
                const msg = selectedStatus?.value === 'delete' ? 'Delete Data Successfully' : 'Product Status Updated'
                selectedStatus?.value === 'delete' && setIsResetSelectedItem(!isResetSelectedItem)
                setShowAlert(msg, itemModal)
                fetchProductList()
            })
            .catch((error) => {
                return Alert({
                    icon: 'error',
                    title: error?.message,
                    message: 'Periksa kembali data produk yang masih belum dilengkapi',
                })
            })
    }

    const props = {
        dataList: productList?.data,
        modal,
        setShowModal,
        onSelectSort,
        query,
        onChangeQuery,
        queryFilter,
        onFilter,
        selectedIds,
        statusOptions: INIT_STATUS,
        selectedStatus,
        onChangeStatus,
        onApply,
        modalMessage,
        onConfirm,
        onExport,
        onSelectItemHandler,
        isLoading,
        isExporting,
        isBulkAction,
        isResetSelectedItem,
        onSyncCompleted: fetchProductList,
    }

    return <ProductList {...props} />
}
